import { useEffect, useState } from 'react';

import { Checkbox, Typography } from 'antd';

import AppModal from '../../../components/AppModal';

const { Text } = Typography;

const CloseAccountModal = ({ isOpen = false, description = '', onCancel, onSubmit }) => {
  const [isCloseConfirmed, setCloseConfirmed] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setCloseConfirmed(false);
    }
  }, [isOpen]);

  function handleChange() {
    setCloseConfirmed(prev => !prev);
  }

  return (
    <AppModal
      confirmButtonText="Close my account"
      confirmButtonDisabled={!isCloseConfirmed}
      title="Close Account"
      isOpen={isOpen}
      handleCancel={onCancel}
      handleConfirm={onSubmit}>
      <div className="py-4">
        <Text>{description}</Text>
        <Checkbox className="mt-4" checked={isCloseConfirmed} onChange={handleChange}>
          I understand that by closing my account, I will lose all access and data on my account.
        </Checkbox>
      </div>
    </AppModal>
  );
};

export default CloseAccountModal;
